import { createMultimediaSubProject } from '../../services/uploadingService';

const getUploadTypeId = uploadType => {
  switch (uploadType) {
    case 'single':
      return 1;
    case 'panorama':
      return 2;
    case 'video':
      return 3;
    default:
      return -1;
  }
}

export const createMultimediaSubprojectRequest = ({projectId, formData }) => {
  const { uploadType, flightName, note, droneType, realEstate } = formData;

  return createMultimediaSubProject({
    projectId: projectId,
    name: flightName,
    description: note,
    type: getUploadTypeId(uploadType),
    drone: droneType.drone,
    re_code: realEstate
  });
}